import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import NumberFormat from 'react-number-format';
import {httpClient} from "../../core/HttpClient";
import { useTranslation } from "react-i18next";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Divider from "@mui/material/Divider";
import DialogContent from "@mui/material/DialogContent";
import Dialog from "@mui/material/Dialog";
import ListItem from "@mui/material/ListItem";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import List from "@mui/material/List";
import Button from "@mui/material/Button";
import ListItemText from "@mui/material/ListItemText";
import CircularProgress from "@mui/material/CircularProgress";
import {getDatabaseInstance} from "../../core/Firebase";
import {getDatabase, onValue, ref} from "firebase/database";
import {getAuth, signInAnonymously} from "firebase/auth";
import Alert from "@mui/material/Alert";
import {DateI18n} from "../DateI18n";
import dayjs from "dayjs";

export default function AccountBilling() {
    const { t } = useTranslation();
    const [accountBills, setAccountBills] = useState([]);
    const [qrCodeData, setQrCodeData] = useState(null);
    const [paymentComplete, setPaymentComplete] = useState(false);
    const [openInfo, setOpenInfo] = useState(false);
    const [loading, setLoading] = useState(false);
    const [reload, setReload] = useState(false);

    useEffect(() => {
        console.log('[AccountOrder]');
        const url = process.env.REACT_APP_API_BASE_URL + '/accounts/me/bills';
        httpClient.get(url)
            .then(res => {
                if (res.data) {
                    setAccountBills(res.data);
                }
            });
    }, []);

    const handleClose = () => {
        setOpenInfo(false)
        if(reload){
            window.location.reload();
        }
    };


    const showPaymentDialog = (data) => {
        setOpenInfo(true);
        setPaymentComplete(false);
        setQrCodeData(null);
        let payload = {
            _id: data._id,
        };
        const urlPayment = process.env.REACT_APP_API_BASE_URL + '/accounts/me/bill/payment';
        httpClient.post(urlPayment, payload)
            .then(res => {
                if(res.data.data){
                    setQrCodeData({orderNo: res.data.orderNo, amount: res.data.amount, qrcodeId: res.data.data.qrcodeId,  base64:res.data.data.qrImage, expired: res.data.expired});
                    let key = res.data.uid;
                    let app = getDatabaseInstance();
                    const db = getDatabase(app);
                    const auth = getAuth(app);
                    signInAnonymously(auth)
                        .then(() => {
                            const statusRef = ref(db, 'payments/' + key);
                            onValue(statusRef, (snapshot) => {
                                const data = snapshot.val();
                                if(data && data.status === 'success'){
                                    setPaymentComplete(true);
                                    setReload(true);
                                }
                            });
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                }
                setLoading(false);
            });
    };



    return (<>
            {accountBills.length > 0 &&
                <>
                    <hr/>
                    <Box m={2}>
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Typography color="textSecondary">
                                {t('pricing.commissionFeeList')}
                            </Typography>
                        </Box>
                        <Box>
                            <List>
                                {accountBills.map((item, itemIndex) => (
                                    <Box key={'item_'+itemIndex}>
                                        <ListItem style={{padding: '0'}}
                                                  sx={{
                                                      "& .MuiListItemSecondaryAction-root": {
                                                          right: "0px!important",
                                                      },
                                                  }}
                                                  secondaryAction={
                                                      <>
                                                          {['PENDING','OVERDUE'].indexOf(item.status) > -1 &&
                                                              <Button variant="contained" color="success" onClick={() => showPaymentDialog(item)}>
                                                                  {t('pricing.payment')}
                                                              </Button>
                                                          }
                                                          {item.status === 'PAID' &&
                                                              <Box display="flex" alignItems="center" >
                                                                  <CheckCircleOutlineIcon color="success" />
                                                                  <Typography variant="body1"
                                                                              ml={1}
                                                                              color="success.main">{t('payment.paid')}</Typography>
                                                              </Box>
                                                          }
                                                      </>
                                                  }
                                        >
                                            <ListItemText disableTypography primary={
                                                <Typography variant="h6"
                                                            color="inherit">
                                                    {t(`common.months.${item.month}.name`)} {item.year}
                                                </Typography>
                                            } secondary={
                                                <Box>
                                                    <Box display="flex" alignItems="center">
                                                        <Box mr={1}><Typography variant="body1" color="gray" >{t('invoice.amount')}</Typography></Box>
                                                        <Typography variant="body1"
                                                                    color="success.main"><NumberFormat value={item.paymentAmount || 0} displayType={'text'} thousandSeparator={true} /> {t('pricing.baht')}</Typography>
                                                    </Box>
                                                    <Typography variant={"caption"} color={item.status === 'OVERDUE'?'red':'inherit'}>
                                                        {t('account.paymentItemMessage', {overdue: dayjs(item.overdueDate).format('DD/MM/YYYY')})}
                                                    </Typography>
                                                </Box>
                                            } />
                                        </ListItem>
                                        <Divider component="li" />
                                    </Box>
                                ))
                                }
                            </List>
                        </Box>
                    </Box>
                </>
            }
            <Dialog
                fullScreen={true}
                open={openInfo}
                aria-labelledby="info-modal-title"
                aria-describedby="info-modal-description"
                onClose={handleClose}
            >
                <AppBar position="static" color="transparent" elevation={0}>
                    <Toolbar variant="dense">
                        <Typography variant="h6" color="inherit" sx={{flexGrow: 1}}>
                            {t('store.confirmPayment')}
                        </Typography>
                        <IconButton edge="start" color="primary" aria-label="black" onClick={e => setOpenInfo(false)}>
                            <CloseIcon/>
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <Divider/>
                <DialogContent>
                    {paymentComplete &&
                        <Box mt={2}>
                            <Alert severity="success">{t('payment.complete')}</Alert>
                            <Box mt={2}>
                                <Button variant="contained"
                                        color="primary"
                                        size="large"
                                        fullWidth={true}
                                        disableElevation
                                        disabled={loading}
                                        onClick={handleClose} >
                                    {t('common.close')}
                                </Button>
                            </Box>
                        </Box>
                    }
                    {!paymentComplete &&
                        <Box>
                            <Box display="flex" justifyContent="center" alignItems="center" mt={1} mb={1}>
                                <Typography variant="h5" >{t('payment.scanForPaid')}</Typography>
                            </Box>
                            <Box display="flex" justifyContent="center" alignItems="center" mt={2}>
                                <img src={`${process.env.REACT_APP_CDN_BASE_URL}/public/assets/promptpay_visa_master.png`} alt="payment network"
                                     style={{width: '100%', maxWidth: '200px'}}/>
                            </Box>
                            {!qrCodeData &&
                                <Box display="flex" justifyContent="center" mt={3} mb={4}>
                                    <CircularProgress size={20}/>
                                </Box>
                            }
                            {qrCodeData &&
                                <>
                                    <Box display="flex" justifyContent="center" alignItems="center" mt={1}>
                                        <img src={`data:image/png;base64,${qrCodeData.base64}`} alt="pay"
                                             style={{width: '100%', maxWidth: '250px'}}/>
                                    </Box>
                                    <Box display="flex" justifyContent="center" alignItems="center" mb={4}>
                                        <Typography variant="body1" color="inherit">{qrCodeData.qrcodeId}</Typography>
                                    </Box>
                                    <Box display="flex" justifyContent="space-between" alignItems="center">
                                        <Typography variant="body1"
                                                    color="inherit">{t('invoice.amount')}</Typography>
                                        <Typography variant="body1"
                                                    color="inherit"><NumberFormat value={qrCodeData.amount} displayType={'text'} thousandSeparator={true} /> {t('pricing.baht')}</Typography>
                                    </Box>
                                    <Box display="flex" justifyContent="space-between" alignItems="center">
                                        <Typography variant="body1"
                                                    color="inherit">{t('invoice.qrExpired')}</Typography>
                                        <Typography variant="body1"
                                                    color="inherit"><DateI18n value={qrCodeData.expired} format="DD MMM YYYY HH:mm" /></Typography>
                                    </Box>
                                </>
                            }
                            <Box mt={2} pb={2} style={{width: '100%'}}>
                                <Button variant="contained"
                                        color="grey"
                                        size="large"
                                        fullWidth={true}
                                        disableElevation
                                        disabled={loading}
                                        onClick={handleClose} >
                                    {t('common.cancel')}
                                </Button>
                            </Box>
                        </Box>
                    }
                </DialogContent>
            </Dialog>
        </>
    )
}